import { useConfigCat } from '@/store/config-cat.store'
import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum'
interface userMonitoring {
  init: () => void
  trackError: (errorLabel: string, context?: object | undefined) => void
  trackErrorApi: (endpoint: string, request: any, error: any) => void
  trackErrorGraphql: (query: string, error: any, request?: any) => void
  trackAction: (actionName: string, context?: object | undefined) => void
}

export const enum ErrorTypes {
  apiOld = 'API-Legacy',
  api = 'API',
  graphQL = 'GraphQL',
  google = 'Google',
  faultyData = 'Faulty-Data',
  feState = 'State-Error',
  textError = 'Text-Error',
}

export default (): userMonitoring => {
  const enableDev = true

  function init() {
    if (enableDev || !import.meta.env.DEV) {
      initDataDog()
    }
  }

  function initDataDog() {
    useConfigCat()
      .getWholeNumberSetting('dataDogSessionReplaySampleRate')
      .then((dataDogSessionReplaySampleRate: number) => {
        datadogRum.init({
          applicationId: String(import.meta.env.VITE_Datadog_ApplicationId),
          clientToken: String(import.meta.env.VITE_Datadog_ClientToken),
          site: String(import.meta.env.VITE_Datadog_Site) as RumInitConfiguration['site'],
          service: String(import.meta.env.VITE_Datadog_Service),
          env: String(import.meta.env.VITE_Env),
          version: String(import.meta.env.VITE_BUILD_ID), //String(import.meta.env.VITE_RELEASE_VERSION).replace(/ /g, '_'),
          sessionSampleRate: 10,
          sessionReplaySampleRate: dataDogSessionReplaySampleRate ?? 0,
          trackUserInteractions: true,
          trackResources: false,
          trackLongTasks: false,
          defaultPrivacyLevel: 'mask-user-input',
          beforeSend: (event) => {
            // discard a RUM action event if it is a click
            if (event.type === 'action' && event.action.type === 'click') {
              return false
            }
            return true
          },
        })
        datadogRum.startSessionReplayRecording()
      })
  }

  async function trackError(errorLabel: string, errorContext: object | undefined = undefined) {
    if (enableDev || !import.meta.env.DEV) {
      datadogRum.addError(errorLabel, {
        context: errorContext,
        featureFlags: await useConfigCat()
          .getAllFeatureFlags()
          .then((flags) => {
            return flags
          }),
      })
    }
  }

  function trackErrorGraphql(query: string, error: string, request?: any) {
    trackError(`${ErrorTypes.graphQL}: ${query} failed`, {
      request: request ?? undefined,
      error: error,
    })
  }

  function trackErrorApi(endpoint: string, request: any, error: any) {
    trackError(
      `${ErrorTypes.api}: ${endpoint} failed | REQUEST:${request} | ERROR:${JSON.stringify(error)} `
    )
  }

  async function trackAction(actionName: string, context: object | undefined = undefined) {
    try {
      datadogRum.addAction(actionName, {
        featureFlags: await useConfigCat()
          .getAllFeatureFlags()
          .then((flags) => {
            return flags
          }),
        booking: context,
      })
    } catch (error: any) {
      trackError(error)
    }
  }

  return {
    init,
    trackError,
    trackErrorApi,
    trackErrorGraphql,
    trackAction,
  }
}
